module.exports = __webpack_public_path__ + "static/media/ODS07.9920fe31.jpg";